import { render, staticRenderFns } from "./onboarding-shell-home.vue?vue&type=template&id=1399b5b8&"
import script from "./onboarding-shell-home.vue?vue&type=script&lang=js&"
export * from "./onboarding-shell-home.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-shell-home.vue?vue&type=style&index=0&id=1399b5b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports